// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"c3a89659","278":"617145db","405":"c01986e2","451":"7210e3e4","488":"f2f58a21","596":"86b73b73","841":"ce0d26f7","885":"b13190cf"}[chunkId] + ".chunk.js";
};